// Sticky header shrink
(function(){
  var h=document.querySelector('.site-header');
  if(!h) return;
  var onScroll=function(){h.classList.toggle('is-scrolled',window.scrollY>20)};
  onScroll();window.addEventListener('scroll',onScroll,{passive:true});
})();

// Product card gallery
document.addEventListener('click',function(e){
  var btn=e.target.closest('.product-card .gallery .nav');
  if(!btn) return;
  var g=btn.closest('.gallery');
  var slides=g.querySelector('.slides');
  var total=slides.children.length;
  var idx=parseInt(slides.dataset.idx||'0',10);
  idx=(idx+(btn.classList.contains('next')?1:-1)+total)%total;
  slides.dataset.idx=idx;
  slides.style.transform='translateX(-'+(idx*100)+'%)';
  g.querySelectorAll('.dots span').forEach(function(d,i){d.classList.toggle('on',i===idx)});
});

// Reviews carousel
(function(){
  document.querySelectorAll('[data-reviews]').forEach(function(root){
    var track=root.querySelector('.reviews-track');
    var dotsWrap=root.querySelector('.reviews-dots');
    if(!track||!dotsWrap) return;
    var total=track.children.length;
    var idx=0;
    function go(i){idx=Math.max(0,Math.min(total-1,i));track.style.transform='translateX(-'+(idx*100)+'%)';dotsWrap.querySelectorAll('button').forEach(function(b,bi){b.classList.toggle('on',bi===idx)})}
    dotsWrap.querySelectorAll('button').forEach(function(b,i){b.addEventListener('click',function(){go(i)})});
    // swipe
    var sx=0;
    track.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
    track.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40){go(idx+(dx<0?1:-1))}});
    go(0);
  });
})();

// Cart drawer
(function(){
  var drawer=document.getElementById('CartDrawer'),back=document.getElementById('CartBackdrop');
  function open(){drawer&&drawer.classList.add('open');back&&back.classList.add('open')}
  function close(){drawer&&drawer.classList.remove('open');back&&back.classList.remove('open')}
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-open]')){e.preventDefault();open()}
    if(e.target.closest('[data-cart-close]')||e.target===back){close()}
  });

  // Add to cart via fetch API
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[data-add-to-cart]');
    if(!form) return;
    e.preventDefault();
    var fd=new FormData(form);
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
      .then(function(r){return r.json()})
      .then(function(){return fetch('/cart.js').then(function(r){return r.json()})})
      .then(function(cart){
        var c=document.querySelector('[data-cart-count]');
        if(c){c.textContent=cart.item_count;c.style.display=cart.item_count>0?'inline-flex':'none'}
        open();
        var body=drawer&&drawer.querySelector('.body');
        if(body){body.innerHTML=cart.items.map(function(i){return '<div style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid rgba(255,255,255,.15)"><img src="'+i.image+'" style="width:64px;height:64px;object-fit:cover"><div><div>'+i.product_title+'</div><div style="color:#aaa;font-size:12px">Qty '+i.quantity+'</div><div>'+(i.line_price/100).toFixed(2)+' '+cart.currency+'</div></div></div>'}).join('')||'<p style="color:#aaa">Your bag is empty.</p>'}
        var foot=drawer&&drawer.querySelector('footer');
        if(foot){foot.innerHTML='<div style="display:flex;justify-content:space-between"><span>Subtotal</span><span>'+(cart.total_price/100).toFixed(2)+' '+cart.currency+'</span></div><a href="/checkout" class="btn btn-solid">Checkout</a>'}
      });
  });
})();
